import * as React from "react";
import { forwardRef } from "react";
const SvgIconCheckCompleted = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16.001, height: 16.001, viewBox: "0 0 16.001 16.001", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11 3a8 8 0 1 0 8 8 7 7 0 0 0-.423-2.519l-1 .981A6.2 6.2 0 0 1 17.77 11 6.77 6.77 0 1 1 11 4.231a6.6 6.6 0 0 1 4.673 1.9l.865-.865A7.8 7.8 0 0 0 11 3m6.943 2.635L11 12.578 8.366 9.943l-.885.885 3.077 3.072.442.423.442-.423 7.385-7.385z", "data-name": "icon/check", transform: "translate(-3 -3)", fill: "#57728a" }));
const ForwardRef = forwardRef(SvgIconCheckCompleted);
export { ForwardRef as ReactComponent };
